<template>
  <div>
    <section class="pc-banner banner-section" id="products">
      <div class="swiper-container gallery-top">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="item in bannerArray"
            :key="item.id"
            :title="item.loadDesc"
            :style="'background-image:url('+item.imagePc+')'"
            :alt="item.loadDesc"
          >
            <div class="banner-video-wrapper" v-if="item.type=='video'">
              <a :href="item.href" target="_blank" rel="noopener noreferrer" class="enter-subject">
                <video :src="item.imagePc" class="banner-video" muted>{{$t('home.video_alt')}}</video>
              </a>
            </div>
            <a
              :href="item.href"
              target="_blank"
              rel="noopener noreferrer"
              class="banner-link"
              v-else-if="item.type=='image'"
            >
              <div class="banner-des-wrapper" v-if="item.titleShow=='Y'">
                <div class="banner-title" v-text="item.title"></div>
                <div class="banner-sub-title" v-text="item.subtitle"></div>
                <div class="banner-des" v-text="item.titleDesc"></div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="thumbnail-container">
        <div class="thumbnail-wrapper">
          <div class="swiper-preview-container">
            <div class="swiper-container gallery-preview">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="item in bannerArray"
                  :key="item.id"
                  :style="'background-image:url('+item.imageLogo+')'"
                ></div>
              </div>
            </div>
            <div class="swiper-button-next swiper-preview-next"></div>
            <div class="swiper-button-prev swiper-preview-prev"></div>
          </div>
        </div>
      </div>
    </section>
    <div class="wap-banner" id="wap_products">
      <div class="swiper-container banner-container">
        <div class="swiper-wrapper swiper-wrapper1">
          <div
            class="swiper-slide"
            v-for="item in bannerArray"
            :key="item.id"
            :style="'background-image:url('+item.imageWap+')'"
          >
            <a class="banner-box" :href="item.href">
              <div class="banner-title-wrapper" v-if="item.titleShow=='Y'">
                <div class="banner-title" v-text="item.title"></div>
                <div class="banner-sub-title" v-text="item.subtitle"></div>
                <div class="banner-des" v-text="item.titleDesc"></div>
              </div>
              <div class="banner-logo" :style="'background-image:url('+item.imageLogo+')'"></div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from "../common/common";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import { getBannerList } from "../../../request/api";
export default {
  data() {
    return {
      bannerArray: [],
      galleryThumbs: null,
      galleryTop: null,
      wapSwiper:null,
      timer:null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var _this = this;
      this.getBannerList();
      _this.initSwiper();
    },
    initSwiper() {
      this.initPCSwiper();
      this.initWapSwiper();
    },
    initPCSwiper(){
      var that = this;
      this.galleryThumbs = new Swiper(".gallery-preview", {
        spaceBetween: 10,
        slidesPerView: 5,
        watchSlidesVisibility: true, //防止不可点击
        observer: true,
        observeParents:true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
      this.galleryTop = new Swiper(".gallery-top", {
        autoplay: {
          delay: 5000
        },
        speed: 500,
        spaceBetween: 10,
        loop: true,
        observer: true,
        observeParents:true,
        effect: "fade",
        touchRatio: 2, //触摸变快
        thumbs: {
          swiper: that.galleryThumbs
        },
        on: {
          resize:function(){
            if (window.innerWidth<800) {
              that.galleryTop.autoplay.stop();
            }
          },
          slideChange: function() {
            // 如果还有视频播放则暂停视频播放
            if($('.pc-banner').css('display')!=='none'){
              $(".gallery-top")
                .find(".swiper-slide")
                .find(".banner-video")
                .each(function() {
                  var preVideoDom = $(this);
                  if (!preVideoDom) {
                    return;
                  }
                  var preVideo = preVideoDom[0];
                  if (!preVideo.paused) {
                    preVideo.load();
                  }
                });
              // 如果这个是视频则播放视频
              if (this.realIndex>=that.bannerArray.length) {
                return;
              }
              if (that.bannerArray[this.realIndex].type && that.bannerArray[this.realIndex].type == "video") {
                var videoDom = $(".gallery-top")
                  .find(".swiper-slide")
                  .eq(this.activeIndex)
                  .find(".banner-video")[0];
                videoDom.play();
              }
            }
          }
        }
      });
      that.galleryThumbs.el.onmouseover = function() {
        that.galleryTop.autoplay.stop();
      };
      that.galleryThumbs.el.onmouseout = function() {
        that.galleryTop.autoplay.start();
      };
      that.galleryTop.el.onmouseover = function() {
        that.galleryTop.autoplay.stop();
      };
      that.galleryTop.el.onmouseout = function() {
        that.galleryTop.autoplay.start();
      };
      this.$nextTick(function() {
        this.initEvent();
      });
    },
    initWapSwiper(){
      var that = this;
      that.wapSwiper = new Swiper(".banner-container", {
        autoplay: {
          delay: 5000
        },
        loop: true,
        slidesPerView: "auto", //重要 可以去swiper搜索
        centeredSlides: true, //重要
        spaceBetween: 20,
        effect: "left",
        touchRatio: 2, //触摸变快
        observer:true,
        observeParents:true,
        disableOnInteraction: false,
        on:{
          resize:function(){
            that.wapSwiper.update();
          },
          touchStart:function () {
            clearTimeout(that.timer);
            that.wapSwiper.autoplay.stop();
            that.timer= setTimeout(() => {
              that.wapSwiper.autoplay.start();
            }, 3000);
          }
        }
      });
    },
    getBannerList() {
      var that = this;
      var localBannerList = localStorage.getItem("bannerList");
      var lang = this.$cookies.get("language");
      if (localBannerList) {
        //先读取缓存的banner图
        that.bannerArray = JSON.parse(localBannerList);
      }
      getBannerList({ language: lang||global.initLang, channel: "HOME" })
        .then(res => {
          if (res.success) {
            that.bannerArray = res.bannerList;
            for (var index = 0; index < that.bannerArray.length; index++) {
              //判断传来的类型
              var imagePc = that.bannerArray[index].imagePc;
              var type = "";
              if (imagePc) {
                var suffix = imagePc.split(".")[imagePc.split(".").length - 1];
                if (
                  suffix.toLowerCase() == "mp4" ||
                  suffix.toLowerCase() == "webm" ||
                  suffix.toLowerCase() == "ogg"
                ) {
                  type = "video";
                } else {
                  type = "image";
                }
                that.bannerArray[index].type = type;
              }
            }
            localStorage.setItem("bannerList", JSON.stringify(res.bannerList));
          }
          that.$nextTick(function() {
            that.initSwiper();
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    initEvent() {
      var _this = this;
      $(".gallery-preview")
        .find(".swiper-slide")
        .hover(function() {
          var slideIndex = $(".gallery-preview")
            .find(".swiper-slide")
            .index($(this));
          _this.galleryTop.slideTo(slideIndex + 1);
        });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pc/index/bannerSection.vue